import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const CashflowPage = lazy(() => import('../components/cashflow'));
const CashflowCounterparties = lazy(() => import('../components/cashflow/CounterpartiesPage'));
const CashflowVaPayments = lazy(() => import('../components/cashflow/VaPaymentsPage'));

export const cashflowRoutes = (
  <>
    <Route path="/cashflow" element={<CashflowPage />} />
    <Route path="/cashflow/counterparties" element={<CashflowCounterparties />} />
    <Route path="/cashflow/va-payments" element={<CashflowVaPayments />} />
  </>
);
